/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { principalRolesControllerCreate } from "./principalRolesControllerCreate";
import { principalRolesControllerFindEligiblePrincipals } from "./principalRolesControllerFindEligiblePrincipals";
import { principalRolesControllerFindOne } from "./principalRolesControllerFindOne";
import { principalRolesControllerFindRoleHolders } from "./principalRolesControllerFindRoleHolders";
import { principalRolesControllerRemove } from "./principalRolesControllerRemove";
import { principalRolesControllerUpdate } from "./principalRolesControllerUpdate";

export function principalRolesService() {
  return { principalRolesControllerCreate, principalRolesControllerFindEligiblePrincipals, principalRolesControllerFindRoleHolders, principalRolesControllerFindOne, principalRolesControllerRemove, principalRolesControllerUpdate }
}